import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createContext, useContext, useState } from "react";
var defaultCandidateContext = {
    CandidateId: null,
    setCandidateId: function () { return undefined; },
};
export var CandidateContext = createContext(defaultCandidateContext);
export var CandidateContextProvider = function (props) {
    var _a = useState(localStorage.getItem("selected-Candidate-event-id") || null), Candidate = _a[0], setCandidate = _a[1];
    var setCandidateId = function (CandidateId) {
        localStorage.setItem("selected-Candidate-event-id", CandidateId || "");
        setCandidate(CandidateId);
    };
    // Setup the context provider
    return (_jsx(CandidateContext.Provider, { value: {
            CandidateId: Candidate,
            setCandidateId: setCandidateId,
        }, children: props.children }));
};
export var useCandidateStore = function () {
    var _a = useContext(CandidateContext), CandidateId = _a.CandidateId, setCandidateId = _a.setCandidateId;
    return [CandidateId, setCandidateId];
};
